import React, { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IAnswerCardItem } from "store/ducks/answerCard";
import { WebpRadioGroup } from "components/WebpRadioGroup";
import { WebpRadioInput } from "components/WebpRadioInput";
import { WebpText } from "components/WebpText";
import { IQuestion } from "../../../../../interfaces/IQuestion";
import { IReduxStore } from "../../../../../interfaces/IReduxStore";
import { Types } from "../../../../../store/ducks/answerCard";

interface IAnswerHit {
    answer?: IAnswerCardItem;
    question?: IQuestion;
}

function AnswerHit({ answer, question }: IAnswerHit) {
    const dispatch = useDispatch();
    const exerciseListState = useSelector((state: IReduxStore) => state.exerciseList);

    const [isCorrect, setIsCorrect] = useState<boolean | undefined>(undefined);

    const handleRadioCheck = (ev: any) => {
        const idAnswerCard = exerciseListState.realizations?.[exerciseListState.realizations.length - 1].id;

        const idQuestion = exerciseListState.currentQuestion?.id;

        const checkedValue = ev.value === "acertei";

        setIsCorrect(checkedValue);

        dispatch({
            type: Types.SET_OPEN_QUESTION_ANSWER_REQUEST,
            payload: {
                checkedValue: { checked: ev.checked, value: checkedValue },
                idQuestion: idQuestion,
                idAnswerCard: idAnswerCard,
                question: question
            }
        });
    };

    return (
        <Fragment>
            <WebpText color="neutral" colorWeight={400} xs="title-xss">
                <p>Minha resposta:</p>
            </WebpText>

            <WebpRadioGroup
                contentGroup={
                    <Fragment>
                        <WebpRadioInput label="Acertei" value="acertei" name="hit" checked={!!isCorrect} onRadioGroupOptionCheck={handleRadioCheck} />

                        <WebpRadioInput
                            label="Errei"
                            value="errei"
                            name="hit"
                            checked={!isCorrect && isCorrect !== undefined}
                            onRadioGroupOptionCheck={handleRadioCheck}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
}

export default AnswerHit;
